import React from "react";

export function FormControlStyles() {
  return (
    <style>{`
      /* Ensure native form controls prefer dark styling where supported */
      .kq-select{ color-scheme: dark; }

      /* Dropdown list (options) */
      .kq-select option{
        background-color: rgba(10, 12, 36, 0.98);
        color: rgba(255, 255, 255, 0.82);
      }
      .kq-select option:disabled{
        color: rgba(255, 255, 255, 0.35);
      }
    `}</style>
  );
}
